import { Link } from 'react-router-dom';
import styles from './Button.module.css';

/**
 * Reusable button / link component.
 *
 * Props:
 *   variant  – 'primary' | 'secondary' | 'outline'  (default: 'primary')
 *   size     – 'sm' | 'md' | 'lg'                   (default: 'md')
 *   to       – internal route  (renders <Link>)
 *   href     – external URL    (renders <a>)
 *   children – button label
 *   …rest   – forwarded to the underlying element
 */
export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  to,
  href,
  className = '',
  ...rest
}) {
  const classes = [
    styles.btn,
    styles[variant],
    styles[size],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} target="_blank" rel="noopener noreferrer" {...rest}>
        {children}
      </a>
    );
  }

  return (
    <button className={classes} {...rest}>
      {children}
    </button>
  );
}
